export const MOBILE_NAV_HEIGHT = 56
export const NAV_HEIGHT = 78
export const MOBILE_BANNER_HEIGHT = 35
export const BANNER_HEIGHT = 44
